import * as angular from "angular";
import { Constants as constants } from "@constants/shared";
import { ProviderRepo as providerRepo } from "@services/fileprovider.repo";
import { fileList } from "@app/fileprovider/fileList";
import { fileInfo } from "@app/fileprovider/viewFile/fileInfo";
import { newFile } from "@app/fileprovider/newFile/newFile";

export const filesModule = "fileprovider";

angular
  .module(filesModule, [
    "ui.router",
    "dataGrid",
    "pagination",
    "angular-loading-bar",
    "angularModalService",
  ])
  .constant("config", constants.Default)
  .service("providerRepo", providerRepo)
  .component("fileList", fileList)
  .component("fileInfo", fileInfo)
  .component("newFile", newFile);



// WEBPACK FOOTER //
// ./src/app/fileprovider/fileprovider.index.ts